/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useRef } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    shape, string, bool, func,
} from 'prop-types';
import { compose } from 'recompose';
import { makeStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import Button from '@material-ui/core/Button';

import withPageView from '../../../helpers/tracking/hocs/withPageView';
import { trackData, trackPage, coreBrowsingPageViewSuccessTest } from '../../../helpers/tracking/common/commonTrackingHelpers';
import { actions as tagManagerActions } from '../../../../state/ducks/TagManager';

import GraphqlSeoHeadTags from '../GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';

const useStyles = makeStyles((theme) => ({
    radioHeader: {
        [theme.breakpoints.up('sm')]: {
            fontSize: '29px',
        },
        display: 'block',
        [theme.breakpoints.down('sm')]: {
            fontSize: '18px',
            lineHeight: '55px',
            backgroundColor: theme.palette.grey9,
            padding: '0 10px',
        },
        whiteSpace: 'nowrap',
    },
    radioContent: {
        [theme.breakpoints.up('sm')]: {
            margin: '14px 0',
            fontSize: '20px',
            fontWeight: '300',
        },
        display: 'block',
        [theme.breakpoints.down('sm')]: {
            color: '#53247f',
            fontSize: '16px',
            fontWeight: 'normal',
            padding: '3px 10px 0',
        },
    },
    root: ({ bgImage }) => ({
        [theme.breakpoints.up('sm')]: {
            background: `url(${bgImage})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: '643px 348px',
            margin: '40px auto 20px',
            width: '643px',
        },
        [theme.breakpoints.down('sm')]: {
            background: 'unset !important',
            margin: '0px',
            width: '100%',
        },
        minHeight: '348px',
        display: 'block',
        position: 'relative',
        fontFamily: theme.typography.fontFamily,

    }),
    suggestion: {
        display: 'block',
    },
    suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: 'none',
        backgroundColor: theme.palette.white,
        overflow: 'auto',
        [theme.breakpoints.up('sm')]: {
            width: '270px',
            maxHeight: '105px',
            marginTop: '5px',
        },
        [theme.breakpoints.down('sm')]: {
            position: 'absolute',
            width: '95.5%',
            maxHeight: '300px',
            zIndex: '99',
            marginTop: '10px',
        },
        boxShadow: '0px 2px 2px 2px rgba(0, 0, 0, 0.2)',
    },
    radioOffersSection: {
        [theme.breakpoints.up('sm')]: {
            width: '65%',
            marginLeft: '35px',
            paddingTop: '10%',
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            marginLeft: '0px',
            paddingTop: '0px',
        },
        display: 'block',
    },

    autoContainer: {
        [theme.breakpoints.up('sm')]: {
            width: '270px',
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            padding: '10px 0px 0px 10px',
        },
        display: 'block',
        position: 'relative',
        float: 'left',
    },
    radioClearIcon: {
        position: 'absolute',
        cursor: 'pointer',
        [theme.breakpoints.up('sm')]: {
            top: '20px',
        },
        [theme.breakpoints.down('sm')]: {
            top: '32px',
        },
        right: '10px',
    },
    radioButton: {
        [theme.breakpoints.down('sm')]: {
            display: 'block',
            padding: '0 10px',
        },
    },
    radioIconAdjust: {
        color: theme.palette.white,
        padding: '3px 0',
        backgroundColor: '#3CAF2B',
        [theme.breakpoints.up('sm')]: {
            display: 'block',
        },
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
        width: '35px',
        minHeight: '35px',
    },
    goButton: {
        border: '2px solid',
        borderColor: theme.palette.bgHeader,
        width: '100%',
        color: theme.palette.bgHeader,
        fontWeight: 'bold',
        backgroundColor: theme.palette.colorNeutral10,
        boxShadow: 'inherit',
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
        [theme.breakpoints.down('sm')]: {
            display: 'block',
        },
    },
    radioInput: {
        width: '100%',
        height: '35px',
        background: 'transparent',
        border: 'none',
        borderBottom: '1px solid #000',
        fontSize: '18px',
    },
    dataLists: {
        position: 'absolute',
        height: '200px',
        overflowY: 'auto',
    },
}));

const RadioPageBlock = ({
    trackEvent,
    data,
    history,
}) => {
    const seo = data?.seo || {};

    const heading = data?.heading || "We Knew You'd Be Listening!";
    const subHeading = data?.sub_heading || 'Enter the name or code you heard below for your special offer';

    const bgImage = data?.image?.url || '//cdn1.1800flowers.com/wcsstore/Flowers/images/banners/radio/1800flowers-radio-codes-v2.jpg';
    const classes = useStyles({ bgImage });
    const inputRef = useRef('');
    const radioOffersResults = () => {
        /* eslint-disable no-useless-escape */
        let searchTermValue = '';
        searchTermValue = inputRef.current.value
            .replace(/[`~!@#$%^&*()_|\-=?;:'",.<>\{\}\[\]\\\/]/g, '')
            .replace(/ /g, '+')
            .toLowerCase();
        if (searchTermValue.trim().length === 0) {
            searchTermValue = 'hostna';
        }
        history.push(`/radio-offers-results/${searchTermValue}`);
    };

    const onKeyPress = (e) => {
        if (e.key === 'Enter') {
            radioOffersResults();
        }
    };

    trackData({
        untData: data,
        action: 'track_radio_interstitial_page_data',
    });

    return (
        <>
            <GraphqlSeoHeadTags seoData={seo} />
            <div className={classes.root}>
                <div
                    tabIndex="-1"
                    className={classes.radioOffersSection}
                >
                    <strong className={classes.radioHeader}>{heading}</strong>
                    <span className={classes.radioContent}>{subHeading}</span>
                    <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                        <div className={classes.autoContainer}>
                            <label htmlFor="radio-offers" aria-label="Enter Radio/TV code">
                                <input
                                    type="text"
                                    list="radio-offers"
                                    ref={inputRef}
                                    className={classes.radioInput}
                                    // onChange={() => onInputValueChange()}
                                    onKeyUp={(e) => onKeyPress(e)}
                                    placeholder="Enter Radio/TV code"
                                />
                            </label>
                            <div className={classes.dataLists}>
                                <datalist id="radio-offers">
                                    {
                                        data.all_aliases.map((d) => <option value={d} />)
                                    }
                                </datalist>
                            </div>
                        </div>
                        <div className={classes.radioButton}>
                            <PlayArrowIcon
                                onClick={() => {
                                    radioOffersResults();
                                    // radio term is dynamic based on the term attached to url path
                                    trackEvent({
                                        eventCategory: 'Radio Interstitial', eventAction: 'Submit Button – [Click]', eventLabel: `${inputRef.current.value}`,
                                    });
                                }}
                                className={classes.radioIconAdjust}
                            />
                            <Button
                                variant="contained"
                                className={classes.goButton}
                                onClick={() => {
                                    radioOffersResults();
                                    // radio term is dynamic based on the term attached to url path
                                    trackEvent({
                                        eventCategory: 'Radio Interstitial', eventAction: 'Submit Button – [Click]', eventLabel: `${inputRef.current.value}`,
                                    });
                                }}
                            >GO
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

const mapDispatchToProps = (dispatch) => ({
    trackEvent: bindActionCreators(tagManagerActions.trackEvent, dispatch),
});

RadioPageBlock.propTypes = {
    history: shape({
        path: string,
    }).isRequired,
    trackEvent: func.isRequired,
    data: shape({
        heading: string,
        sub_heading: string,
        image: shape({
            title: string,
            url: string,
        }),
        seo: shape({
            keywords: string,
            meta_description: string,
            page_title: string,
            seo_serchable: bool,
        }),
    }).isRequired,
};

const enhance = compose(
    withRouter,
    trackPage(),
    withPageView({
        pageViewSuccessTest: coreBrowsingPageViewSuccessTest,
    }),
    connect(null, mapDispatchToProps),
);

export default enhance(RadioPageBlock);
